module.exports = __webpack_public_path__ + "static/img/105740.1c48a494.png";